/**
 * By importing and 're-exporting' our components in a directory like this, we can import them elsewhere more cleanly.
 * Specifically, we can import multiple things in a single import statement.
 * 
 * 
 * But if you wanted two things from this directory (or some of its utility functions), you'd have to do that multiple times.
 * 
 * By re-exporting our components from index.js files like this, importing mulitple utils into other files now looks like this:
 * `import { debugString, Json } from 'lib/util'`
 * 
 * 
 */
import Json from './Json.svelte'
import Meta from './Meta.svelte'

import { clickOutside } from './js/clickOutside'
import { addDepartmentSidebarMenuFunctionality } from './js/departmentVertical'
import { addDepartmentMainMenuFunctionality } from './js/departmentMainMenu'
import { debounce } from './js/debounce'
import { $utils } from './js/jQueryish'

const slugify = (str = "") => str.toLowerCase().replace(/ /g, "-").replace(/\./g, "")

const uniqueID = ()=> Math.floor(Math.random() * 100)

/**
 * A shorthand function for taking a variable and stringifying it using JSON.stringify(myDataStructureVariableIWantToSee, null, 2)
 * This makes it easy to see the data available to a component as you're working on it.
 * 
 * @param {any} stringifyMe 
 * @returns {string}
 */
const debugString = (stringifyMe = '')=> {
  return JSON.stringify(stringifyMe, null, 2)
}

/**
 * This is a Svelte action. If you use:teleport on a component, 
 * it'll 'teleport' the component to the 'portal' div at the end of the body when it's mounted.
 * @param {*} node
 * @param {*} name
 * @returns 
 */
const teleport = (node, name = 'portal')=> {
	
	let teleportContainer = document.getElementById(name);
	teleportContainer.appendChild(node);

	return {
		destroy() {
			node.remove();
		}
	}
}

const getSiblings = (ele)=> {
  return [...ele.parentElement.children].filter(c => c.nodeType == 1 && c != ele)
}

export {
  // jQuery-like utils
  $utils,
  
  // functions
	addDepartmentSidebarMenuFunctionality,
	addDepartmentMainMenuFunctionality,
  clickOutside,
  debounce,
  debugString,
  getSiblings,
  slugify,
  teleport,
  uniqueID,

  // components
  Json,
  Meta,
}